module.exports = __webpack_public_path__ + "static/media/ODS15.12f2cdb0.svg";